import { useAuth0 } from "@auth0/auth0-react";
import { Redirect, RouteProps } from "react-router-dom";
import Loading from "views/Loading";
import { appConfig } from "env-config";
import { decodeToken } from "react-jwt";
import { TokenProps } from "providers/Settings/UserAuthProvider";

// import AuthLoading from "@view/Auth/Loading";
export const ChangeLayout = () => {
  const { user } = useAuth0();
  const clientId = appConfig.REACT_APP_AUTH0_CLIENT_ID;
  const audience = appConfig.REACT_APP_AUTH0_AUDIENCE;
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    )
  );

  const decodedToken = decodeToken(userInfos?.body.access_token) as TokenProps;
  return (
    <>
      {user.sub.split("|")[0] === "waad" ? (
        <Redirect to="/admin/home" />
      ) : (
        <Redirect to="/supplier/pedidos" />
      )}
    </>
  );
};
